<template>
  <nav id="breadcrumbs" class="col-md-12">
    <ol
      class="breadcrumb"
      itemscope="itemscope"
      itemtype="https://schema.org/BreadcrumbList"
    >
      <li
        v-for="(crumb, idx) in crumbs"
        :key="idx"
        itemscope="itemscope"
        itemtype="https://schema.org/ListItem"
        itemprop="itemListElement"
      >
        <nuxt-link itemprop="item" :to="crumb.permalink">
          <span itemprop="name">{{ crumb.name }}</span>
        </nuxt-link>
        <meta itemprop="position" :content="idx + 1" />
      </li>
    </ol>
  </nav>
</template>

<script>
import normalizePath from '~/commun/utils/normalizePath'
export default {
  name: 'BreadCrumbs',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    crumbs() {
      return [
        { name: this.$t('home.title'), permalink: '' },
        ...this.items,
      ].map((crumb) => ({
        ...crumb,
        permalink: normalizePath(crumb.permalink),
      }))
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~/assets/css/_breadcrumbs.scss';
</style>
